module.exports = __webpack_public_path__ + "img/bars-sort.16473f1d.svg";